import React from 'react';
import PropTypes from 'prop-types';
import { StyledBackgroundBox } from './styled';
import Typography from '../Typography';
import { makeStyles } from '../../utils/styles';
import useTheme from '../../hooks/useTheme';

const useStyles = makeStyles(css => ({
    topText: css`
        margin-bottom: 10px;
        font-size: 14px;
        line-height: 25px;
    `,
    font: css`
        font-size: 32px;
        line-height: 36px;
        font-weight: 900;
        margin-top: auto;
    `
}));

const BackgroundBox = ({ topText, bottomText, backgroundColor, customStyle }) => {
    const styles = useStyles();
    const theme = useTheme();

    return (
        <StyledBackgroundBox backgroundColor={backgroundColor} customStyle={customStyle}>
            <Typography
                color={theme.colors.white}
                customStyle={styles.topText}
                dangerouslySetInnerHTML={{ __html: topText }}
            />
            <Typography
                customStyle={styles.font}
                color={theme.colors.white}
            >
                {bottomText}
            </Typography>
        </StyledBackgroundBox>
    )
}


BackgroundBox.propTypes = {
    topText: PropTypes.string,
    bottomText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    customStyle: PropTypes.array
};

BackgroundBox.defaultProps = {
    topText: '',
    bottomText: ''
};

export default React.memo(BackgroundBox);
